module.exports = __webpack_public_path__ + "img/graph_9.7082893f.png";